import { QueryParams } from 'common/urls/QueryParams';
import { DishFirstSegmentFilter, Protein } from 'src/gqlReactTypings.generated.d';
import { QueryParamsUpdates } from 'src/pages/consumer/explore/useExploreUrl';
import { DietaryTags } from 'web-common/src/shared/Enums';

export type BrowseByTagsUrlFilters = Pick<
  QueryParamsUpdates<DishFirstSegmentFilter>,
  QueryParams.BROWSE_FILTER | QueryParams.DIETARY_FILTER | QueryParams.PROTEIN_FILTER
>;

export type BrowseByTagsDietaryTags = DietaryTags;

export type BrowseByTagsProteinTags = Protein;

export type BrowseByTagsFilterTags = BrowseByTagsDietaryTags | BrowseByTagsProteinTags;

export type BrowseByTagsCollectionTags = Extract<
  DishFirstSegmentFilter,
  | DishFirstSegmentFilter.FamilySize
  | DishFirstSegmentFilter.KidFriendly
  | DishFirstSegmentFilter.Desserts
  | DishFirstSegmentFilter.Healthy
  | DishFirstSegmentFilter.WalletFriendly
  | DishFirstSegmentFilter.Classics
>;

const OnlyAllowedValues: BrowseByTagsFilterTags[] = [...Object.values(Protein), ...Object.values(DietaryTags)];

export const ListOfBrowseByTagsFiltersTags: string[] = OnlyAllowedValues;
